import {
  container,
  cardTitle,
  whiteColor,
  grayColor,
} from "./material-dashboard-pro-react.js";

const loginPageStyle = (theme) => ({
  container2: {
    ...container,
    minHeight: "50px",
  },
  container: {
    ...container,
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "100px",
    },
  },
  title: {
    color: whiteColor,
  },
  cardTitle: {
    ...cardTitle,
    color: whiteColor,
  },
  textCenter: {
    textAlign: "center",
  },
  justifyContentCenter: {
    justifyContent: "center !important",
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: whiteColor,
    },
    marginLeft: "5px",
    marginRight: "5px",
  },
  inputAdornment: {
    marginRight: "18px",
  },
  inputAdornmentIcon: {
    color: grayColor[6],
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)",
  },
  cardHeader: {
    marginBottom: "20px",
  },
  socialLine: {
    padding: "0.9375rem 0",
  },
  select: {
    backgroundColor: "white",
    height: "25px",
    // padding: "7px 24px 7px 10px",
    border: "1px solid black",
    borderRadius: "5px",
    borderColor: "#bdbdbd",
    "&:focus": {
      backgroundColor: "white",
      borderRadius: "5px",
    },
  },
  input: {
    backgroundColor: "white",
    borderRadius: "4px",
    // marginBottom: "20px",
  },
});

export default loginPageStyle;
